import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getSave = createSelector(getModel, (model) => model.save);

export const getIsSaving = createSelector(getSave, (save) => save.isSaving);

export const getDataSave = createSelector(getSave, (save) => save.data);

export const getErrorsSave = createSelector(getSave, (save) => save.errors);

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);

// SYSTEM TYPES
export const getSystemTypes = createSelector(
    getModel,
    (model) => model.systemTypes,
);

export const getIsFetchingSystemTypes = createSelector(
    getSystemTypes,
    (value) => value.isFetching,
);

export const getSystemTypesData = createSelector(
    getSystemTypes,
    (value) => value.data,
);

export const getSystemTypesErrors = createSelector(
    getSystemTypes,
    (value) => value.errors,
);
